import ServiceError from '../../core/errors/ServiceError';
import loadServiceContextual from './loadServiceContextual';
import loadServicePOC from './loadServicePOC';

export default function loadServiceFactory(config) {
  switch (config.service) {
    case 'POC':
      return loadServicePOC(config);
    case 'CONTEXTUAL':
      return loadServiceContextual(config.url);
    default:
      throw new ServiceError('Type of service not recognized', '0500');
  }
}
